import { proxy } from "valtio";
import { createHydrationSafeSnapshotHook } from "src/hooks/create-hydration-safe-snapshot-hook/create-hydration-safe-snapshot-hook";

export interface IDetailPageStore {
    indexLevel: number;
}

export const detailPageStore = proxy({
    indexLevel: 0,

    setIndexLevel(indexLevel: number) {
        detailPageStore.indexLevel = indexLevel;
    },
});

export const useDetailPageStore = createHydrationSafeSnapshotHook(detailPageStore);
